<h3 class="h3 header"><strong>{{ heading }}</strong></h3>
<div class="container" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="center">
  <div *ngFor="let number of phoneNumbers" fxFlex>
    <p class="p3" *ngIf="phoneNumbers.length !== 1 && !!number.heading">{{number.heading}}</p>
    <a
      tabindex="0"
      [attr.aria-label]="'Call ' + number.heading + number.phone"
      href="tel: {{number.phone.replace(' ', '').replace('-', '')}}"
      ><p class="p2">{{number.phone}}</p></a
    >
  </div>
</div>
